var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLectureinfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9091 0L10.0455 3.6V12.4L13.9091 8.8V0ZM4.25 2.4C2.74318 2.4 1.12045 2.72 0 3.6V15.328C0 15.528 0.193182 15.728 0.386364 15.728C0.463636 15.728 0.502273 15.672 0.579545 15.672C1.62273 15.152 3.12955 14.8 4.25 14.8C5.75682 14.8 7.37955 15.12 8.5 16C9.54318 15.32 11.4364 14.8 12.75 14.8C14.025 14.8 15.3386 15.048 16.4205 15.648C16.4977 15.688 16.5364 15.672 16.6136 15.672C16.8068 15.672 17 15.472 17 15.272V3.6C16.5364 3.24 16.0341 3 15.4545 2.8V13.6C14.6045 13.32 13.6773 13.2 12.75 13.2C11.4364 13.2 9.54318 13.72 8.5 14.4V3.6C7.37955 2.72 5.75682 2.4 4.25 2.4Z",
    fill: "#FFE5BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLectureinfo);
export default __webpack_public_path__ + "static/media/lectureinfo.128c30a10a341ec7584255120cd6c493.svg";
export { ForwardRef as ReactComponent };